// PRICE RATING
export type PriceRating = "Great Price" | "Good Price" | "Fair Price" | "Fully Priced";
/** Stored prospect_listings.price_rating values. */

// PRICE RATING ORDER
export const PRICE_RATING_ORDER: readonly PriceRating[] = [
    "Great Price",
    "Good Price",
    "Fair Price",
    "Fully Priced",
];
/** Display order for legends and tags, from the strongest discount to fully priced. */

// PRICE RATING COLOURS
export const PRICE_RATING_COLOURS: Record<PriceRating, string> = {
    "Great Price": "#3DDC6A",
    "Good Price": "#4E9A62",
    "Fair Price": "#8C6A3D",
    "Fully Priced": "#7A2E2E",
};
/** Fill colours for price-rating tags and chart ranges. */
